import { memo } from 'react';
import Box from '../Box/Box';
import { RadioListProps } from './Radio.types';
import RadioButton from './RadioButton';

function RadioList({ options, value, onValue }: RadioListProps) {
  return (
    <Box gap="space-500">
      {options.map((option) => (
        <RadioButton
          key={option.value}
          label={option.label}
          onValue={onValue}
          locKey={option.locKey}
          locNS={option.locNS}
          value={option.value}
          selected={option.value === value}
        />
      ))}
    </Box>
  );
}

export default memo(RadioList);
